import { render, staticRenderFns } from "./Dialects.vue?vue&type=template&id=5deea3b7&"
import script from "./Dialects.vue?vue&type=script&lang=js&"
export * from "./Dialects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports